import { useState, useEffect } from 'react'
import { getNostrPool } from '../lib/nostrPool'
import { RELAYS } from '../config/constants'

export interface Room {
    id: string
    identifier: string
    name: string
    about: string
    picture: string
    pubkey: string
    created_at: number
}

const pool = getNostrPool()

export function useNostrRooms() {
    const [rooms, setRooms] = useState<Room[]>([])
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        let isMounted = true

        const fetchRooms = async () => {
            setIsLoading(true)
            try {
                const filters = [
                    {
                        kinds: [39000],
                        '#t': ['mavililer']
                    }
                ]

                const events = await pool.querySync(RELAYS, filters[0])

                if (!isMounted) return

                const formattedRooms: Room[] = events.map(event => {
                    const dTag = event.tags.find(t => t[0] === 'd')?.[1] || ''
                    const name = event.tags.find(t => t[0] === 'name')?.[1] || dTag
                    const about = event.tags.find(t => t[0] === 'about')?.[1] || ''
                    const picture = event.tags.find(t => t[0] === 'picture')?.[1] || ''

                    return {
                        id: event.id,
                        identifier: dTag,
                        name,
                        about,
                        picture,
                        pubkey: event.pubkey,
                        created_at: event.created_at
                    }
                })

                // Filter duplicates and sort by created_at
                const uniqueRooms = Array.from(new Map(formattedRooms.map(r => [r.identifier, r])).values())
                setRooms(uniqueRooms.sort((a, b) => b.created_at - a.created_at))
            } catch (error) {
                console.error('Failed to fetch rooms:', error)
            } finally {
                if (isMounted) setIsLoading(false)
            }
        }

        fetchRooms()

        return () => {
            isMounted = false
        }
    }, [])

    return { rooms, isLoading }
}
